var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerFilledMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.84575L3.84428 2.50146L12 10.6542L21.5 20.1542L20.1557 21.4985L18.0013 19.35C16.888 20.2652 15.5648 20.9283 14.1124 21.2614V19.083C14.9886 18.8189 15.7838 18.3808 16.4919 17.8377L12 13.3457V20.4422L6.72189 15.1641H2.5V8.8328H7.48705L2.5 3.84575ZM18.817 14.789C19.1711 13.9278 19.3871 12.9946 19.3871 12.0014H19.3901C19.3901 8.65573 17.1606 5.83214 14.112 4.92595V2.74749C18.3399 3.70769 21.4995 7.48849 21.4995 12.0044C21.4995 13.5858 21.1035 15.0741 20.4163 16.3884L18.817 14.789ZM14.1097 7.75256C15.6696 8.52952 16.7467 10.1372 16.7472 12C16.7472 12.2275 16.7321 12.452 16.6992 12.6736L14.1097 10.084V7.75256ZM12 3.55772L9.79153 5.76318L12 7.96865V3.55772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerFilledMuted);
export default __webpack_public_path__ + "static/media/SpeakerFilledMuted.708b49e79bb89f3bf687fae641e49b43.svg";
export { ForwardRef as ReactComponent };